import { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import { createAxiosInstance, normalizeUrl } from './base-client';

const AXIOS_INSTANCE = createAxiosInstance({
  baseURL: import.meta.env.VITE_POINT2_API_URL,
  headers: { 'Exclude-Header': 'Www-Authenticate' },
});

AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error?.response?.data?.error_code
          && error?.response?.data?.desc
          && error?.response?.data?.detail
          && error?.response?.data?.link
    ) {
      return Promise.reject(new LunaError(error));
    }
    return Promise.reject(error);
  },
);

// The mutator function
export const point2AxiosClient = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig, // Optional: capture additional options
): Promise<T> => {
  // console.log(config, options);
  return AXIOS_INSTANCE({
    ...config,
    ...options,
  }).then((response: AxiosResponse<T>) => response.data);
};

export function getArtemySampleUrl(
  sampleType: 'faces' | 'bodies',
  sampleId?: string | null,
): string | undefined {
  if (!sampleId) return undefined;

  return normalizeUrl(`${import.meta.env.VITE_POINT2_API_URL}/1/samples/${sampleType}/${sampleId}`);
}

export function proxyArtemyUrl(url?: string | null): string | undefined {
  if (!url) return undefined;

  return `${import.meta.env.VITE_POINT2_API_URL}${url}`;
}

// Бэкенд отдаёт плейлист ретрансляции url на свой loopback (http://127.0.0.1:8888/{stream}-{session}/index.m3u8),
// недоступный из браузера. Пересобираем на прокси-путь ретранслятора (env VITE_RETRANSLATOR_PATH,
// по умолчанию /api/retranslator): hls.js и его сегменты идут через тот же origin, что и фронт.
export function getRestreamPlaylistUrl(
  url: string,
  retranslatorBase = import.meta.env.VITE_RETRANSLATOR_PATH ?? '/api/retranslator',
): string {
  const { pathname, search } = new URL(url);
  return normalizeUrl(`${retranslatorBase}${pathname}${search}`);
}
